<template>	
	<v-container class="noMargin">	
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('VIEW_REGIONS') !== -1">
      <v-flex lg8 style="padding: 12px;">
      <div class="screenTip">
            <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> If the locations are not displaying on
              the CTA form in the app check that the upper location has been setup in the database with a parent of 0.
                    </span>
      </div>
      </v-flex>
      <v-flex lg4>
        <v-btn @click.prevent="fncAddRegion" class="elevation-5	" color="info"><i class="material-icons">add</i>Create Region</v-btn>
        <v-btn @click.prevent="fncReloadRegions" class="elevation-5	" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
      </v-flex>
			<v-flex lg12>
				<div class="pageTitle">
					<h2>REGIONS</h2>					
				</div>

			</v-flex>
		</v-layout>		
    </v-container>  
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddRegion() {
              this.$store.dispatch('setObjRegionParents', '');					
				var modalDetails = { title: 'Add Region', component: 'modal-region-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncReloadRegions() {
              this.$store.dispatch({
                type: 'fncPopulateRegionList',
                reload: true
              });              
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'		
			])
		}  
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>